export default function EuRailFareConditionsModalService(
    railsService
) {
    'ngInject';

    Object.assign(this, {
        getFareTypes,
    });

    function getFareTypes(fareTypeIds) {
        return railsService.getFareTypes(fareTypeIds);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/eurail-fare-conditions-modal/eurail-fare-conditions-modal-service.js